const ANCILLARY_TYPES = {
  TRAVELER_ANCILLARY: 'TravelerAncillary',
  PAID_TRAVELER_ANCILLARY: 'PaidTravelerAncillary',
  TICKETED_TRAVELER_ANCILLARY: 'TicketedTravelerAncillary',
  CABIN_TRAVELER_ANCILLARY: 'CabinUpgradeAncillary',
};

export default ANCILLARY_TYPES;
